export type BillingTerm = 'M' | 'Y';

export const YEARLY_DISCOUNT = 0.85;

export interface Plan {
  id: string;            // canonical slug used by the pricing page, e.g. 'starter'
  paymentId: string;     // numeric id used by the payment page + gateways, e.g. '2'
  name: string;
  monthlyUsd: number;    // USD charged per month
  yearlyUsd?: number;    // optional override; defaults to monthlyUsd × 12 × YEARLY_DISCOUNT
  documents: string;
}

// ─────────────────────────────────────────────────────────────────────────────
// SINGLE SOURCE OF TRUTH FOR ALL PRICING.
// Change a number here and it propagates to the pricing page, the payment
// page, and the SEO structured data. Do NOT hardcode prices elsewhere.
// ─────────────────────────────────────────────────────────────────────────────
export const PLANS: Plan[] = [
  { id: 'free',       paymentId: '1', name: 'Free',       monthlyUsd: 0,   documents: 'Up to 5 documents/month' },
  { id: 'starter',    paymentId: '2', name: 'Starter',    monthlyUsd: 5,  documents: 'Up to 100 documents/month' },
  { id: 'core',       paymentId: '3', name: 'Core',       monthlyUsd: 25,  documents: 'Up to 600 documents/month' },
  { id: 'business',   paymentId: '4', name: 'Business',   monthlyUsd: 39,  documents: 'Up to 1,000 documents/month' },
  { id: 'proAdvisor', paymentId: '5', name: 'ProAdvisor', monthlyUsd: 149, documents: 'Documents/month (optionally pooled)' },
  { id: '9',          paymentId: '9', name: 'Test',       monthlyUsd: 1,   yearlyUsd: 1, documents: 'Payment Gateway Test — $1 charge' },
];

export const PLANS_BY_ID: Record<string, Plan> = Object.fromEntries(
  PLANS.map((plan) => [plan.id, plan]),
);

export const PLANS_BY_PAYMENT_ID: Record<string, Plan> = Object.fromEntries(
  PLANS.map((plan) => [plan.paymentId, plan]),
);

export function getYearlyUsd(plan: Plan): number {
  if (plan.yearlyUsd !== undefined) return plan.yearlyUsd;
  return Math.round(plan.monthlyUsd * 12 * YEARLY_DISCOUNT);
}

export function getPlanPriceUsd(monthlyUsd: number, term: BillingTerm): number {
  if (term === 'Y') return Math.round(monthlyUsd * 12 * YEARLY_DISCOUNT);
  return monthlyUsd;
}